<template>
	<Card :title="enrollment.user.last_name" :subtitle="enrollment.user.names">
		<template #badges>
			<Badge :color="badgeColor" active>{{ enrollment.score }}%</Badge>
			<Badge class="cursor-pointer" @click.stop="copyTextToClipboard(enrollment.id.toString())">#{{ enrollment.id }}</Badge>
		</template>
		<template v-if="allowSwitching" #footer>
			<SecondaryButton v-if="enrollment.is_accepted" :color="Color.Red" @click.stop="$emit('reject')">
				<i class="fa-solid fa-thumbs-down mr-2"/>
				{{ trans('general.reject') }}
			</SecondaryButton>
			<SecondaryButton v-if="enrollment.is_rejected" :color="Color.Green" @click.stop="$emit('accept')">
				<i class="fa-solid fa-thumbs-up mr-2"/>
				{{ trans('general.accept') }}
			</SecondaryButton>
		</template>
	</Card>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import {copyTextToClipboard} from '@/Helpers/general'
import {type Enrollment} from '@/Types/Events/Enrollment'
import {getEnrollmentStatusColor} from '@/Helpers/Events/enrollments'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {computed, type ComputedRef, defineEmits, defineProps, ref, type Ref} from 'vue'

const props = defineProps<{
	enrollment:Enrollment,
	allowSwitching:boolean,
}>()

defineEmits([
	'accept',
	'reject',
])

const enrollment:Ref<Enrollment> = ref(props.enrollment)

const badgeColor:ComputedRef<Color> = computed(():Color => {
	return getEnrollmentStatusColor(enrollment.value.status)
})
</script>
